import DatetimeUtils from "../../../../../../core/gd/utils/datetime-utils"
import ModelEntity from "../../../../../../core/model2/model-entity"
import {EntityType} from "../../../../../../core/gd/const/item"
import {ContentRTF} from "../../../../../../core/gd-components/editor/@type"

export default class GenericUpdate extends ModelEntity {

    public momentCreated    : Moment
    public title            : string
    public message          : string
    public messageRTF       : ContentRTF | null
    public updateType       : any

    constructor(data:any) {
        super(data.id, EntityType.UPDATE_GENERIC)

        this.momentCreated  = DatetimeUtils.datetimeToMoment(data['momentCreated'])
        this.title          = data.params?.title
        this.message        = data.params?.message
        this.messageRTF     = data.params?.messageRTF || null
        this.updateType     = data['updateType']
    }
}
